const SessionActionType = {
  SESSION_SET_ROLE: 'session_set_role',
  SESSION_SET_LANG: 'session_set_lang',
  SESSION_RESET: 'session_reset',
} as const;

export default SessionActionType;
